import { periodSearch } from '../period/period.search';

/** One tenant's usage over the chosen period (the same period as the tenant list it came from). */
export const platformTenantUsageSearch = periodSearch;
